export const phoneMask = (number: string) =>
  "+# (###) ###-##-##".replaceAll("#", (_, index) => {
    const symbolLength = "+# (###) ###-##-##".slice(0, index).replaceAll("#", "").length;
    const currentIndex = index - symbolLength;
    return number[currentIndex];
  });
